import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import * as accountActions from 'modules/account';

class LegacyTemplateMigrationBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dismissed: false,
      showConfirmDialog: false,
      migrating: false,
      error: null
    };
  }

  handleDismiss = () => {
    this.setState({ dismissed: true });
  }

  handleMigrate = () => {
    this.setState({ showConfirmDialog: true });
  }

  handleConfirmMigration = async () => {
    this.setState({ migrating: true, error: null });

    try {
      const response = await fetch('/account/migrate-from-legacy', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include'
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Migration failed');
      }

      // Update Redux store with new user data (includes dateCreated)
      const { dispatch } = this.props;
      dispatch(accountActions.fetchAccountSuccess(data.user));

      // Close dialog and reload page to reflect changes
      this.setState({ showConfirmDialog: false, migrating: false });
      window.location.reload(true);
    } catch (error) {
      this.setState({
        migrating: false,
        error: error.message,
        showConfirmDialog: false
      });
    }
  }

  handleCancelMigration = () => {
    this.setState({ showConfirmDialog: false });
  }

  render() {
    const { user } = this.props;
    const { dismissed, showConfirmDialog, migrating, error } = this.state;

    // Don't show banner if user has dateCreated (already migrated) or dismissed
    if (user.dateCreated || dismissed) {
      return null;
    }

    return (
      <div>
        {/* Migration Banner */}
        <div className="legacy-migration-banner">
          <div className="legacy-migration-content">
            <i className="fa fa-exclamation-triangle" style={{marginRight: '10px', fontSize: '20px'}}></i>
            <div className="legacy-migration-text">
              <strong><FormattedMessage id="templates.legacyWarningTitle" defaultMessage="You're using the deprecated legacy template" /></strong>
              <p><FormattedMessage id="templates.legacyWarning" defaultMessage="Modern templates offer better features, support, and regular updates. We recommend migrating to a modern template." /></p>
            </div>
            <div className="legacy-migration-actions">
              <button
                className="btn btn-warning"
                onClick={this.handleMigrate}
                disabled={migrating}
              >
                <FormattedMessage id="templates.migrateButton" defaultMessage="Migrate to Modern Templates" />
              </button>
              <button
                className="btn btn-link"
                onClick={this.handleDismiss}
                style={{marginLeft: '10px'}}
              >
                <FormattedMessage id="templates.dismissButton" defaultMessage="Dismiss" />
              </button>
            </div>
          </div>
          {error && (
            <div className="alert alert-danger" style={{marginTop: '10px', marginBottom: '0'}}>
              {error}
            </div>
          )}
        </div>

        {/* Confirmation Dialog */}
        {showConfirmDialog && (
          <div className="modal legacy-migration-modal" style={{
            display: 'block',
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 99999,
            overflow: 'auto'
          }}>
            <div className="modal-dialog modal-lg" style={{transform: 'none', marginTop: '50px'}}>
              <div className="modal-content">
                <div className="modal-header">
                  <button type="button" className="close" onClick={this.handleCancelMigration}>
                    <span>&times;</span>
                  </button>
                  <h4 className="modal-title">
                    <FormattedMessage id="templates.migrationConfirmTitle" defaultMessage="Confirm Migration" />
                  </h4>
                </div>
                <div className="modal-body" style={{fontSize: '15px'}}>
                  <p style={{fontSize: '16px', marginBottom: '15px'}}>
                    <FormattedMessage
                      id="templates.migrationConfirm"
                      defaultMessage="Are you sure you want to migrate? This will:"
                    />
                  </p>
                  <ul style={{fontSize: '15px', lineHeight: '1.8', marginBottom: '20px'}}>
                    <li><FormattedMessage id="templates.migrationConfirm1" defaultMessage="Hide the legacy template permanently" /></li>
                    <li><FormattedMessage id="templates.migrationConfirm2" defaultMessage="You must have at least one modern template installed" /></li>
                    <li><FormattedMessage id="templates.migrationConfirm3" defaultMessage="This change cannot be reverted" /></li>
                  </ul>
                  <p className="text-muted" style={{fontSize: '14px', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '4px'}}>
                    <strong>Note:</strong>{' '}
                    <FormattedMessage
                      id="templates.migrationConfirmNote"
                      defaultMessage="If you haven't installed a modern template yet, please do so before migrating."
                    />
                  </p>
                </div>
                <div className="modal-footer" style={{padding: '15px'}}>
                  <button
                    type="button"
                    className="btn btn-default btn-lg"
                    onClick={this.handleCancelMigration}
                    disabled={migrating}
                    style={{fontSize: '16px', padding: '10px 20px'}}
                  >
                    <FormattedMessage id="templates.cancel" defaultMessage="Cancel" />
                  </button>
                  <button
                    type="button"
                    className="btn btn-warning btn-lg"
                    onClick={this.handleConfirmMigration}
                    disabled={migrating}
                    style={{fontSize: '16px', padding: '10px 20px'}}
                  >
                    {migrating ? (
                      <span><i className="fa fa-spinner fa-spin"></i> <FormattedMessage id="templates.migrating" defaultMessage="Migrating..." /></span>
                    ) : (
                      <FormattedMessage id="templates.confirmMigrate" defaultMessage="Yes, Migrate Now" />
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.account || state.user
});

export default connect(mapStateToProps)(LegacyTemplateMigrationBanner);



// WEBPACK FOOTER //
// app/components/LegacyTemplateMigrationBanner.jsx